import { BaseService } from './BaseService';

export const SuperAgentName = 'SuperAgent';

export interface AgentSelectListItem {
    value: string;
    text: string;
    name: string;
    selected?: boolean;
    isDocumentUploadEnabled: boolean;
}

export class AgentService extends BaseService {
    async getAgentSelectListItems(endpoint: string, accessToken?: string): Promise<AgentSelectListItem[]> {
        return this.getResponseAsync(
            {
                commandPath: endpoint,
                method: 'GET',
            },
            accessToken,
        );
    }
}
